import { styled } from "@linaria/react";

import FlexWrapper from "@gx/dls/containers/FlexWrapper";
import Text, { TextVariant, TextWeight } from "@gx/dls/text/Text";
import { withTheme } from "@gx/dls/theme";
import { PropsWithTheme } from "@gx/dls/theme/types";

import { EDIT_SOURCE_DRAWER_TAB_LABELS } from "@/pages/sources/components/edit/constants";
import { EditSourceDrawerTab } from "@/pages/sources/components/edit/types";

const TabItem = withTheme(styled.button<PropsWithTheme & { $isSelected: boolean }>`
  background: none;
  border: none;
  padding: 8px 12px;
  margin-bottom: -0.5px;
  cursor: pointer;
  border-bottom: 1px solid
    ${({ theme, $isSelected }) => ($isSelected ? theme.color.text.primary : "transparent")};
  transition: border-color 0.15s ease;
`);

interface EditSourceDrawerTabsProps {
  activeTab: EditSourceDrawerTab;
  onTabChange: (tab: EditSourceDrawerTab) => void;
}

const EditSourceDrawerTabs = ({ activeTab, onTabChange }: EditSourceDrawerTabsProps) => {
  return (
    <FlexWrapper gap={6}>
      {Object.values(EditSourceDrawerTab).map((tab) => (
        <TabItem key={tab} $isSelected={activeTab === tab} onClick={() => onTabChange(tab)}>
          <Text
            variant={activeTab === tab ? TextVariant.PRIMARY : TextVariant.SECONDARY}
            weight={TextWeight.MEDIUM}
          >
            {EDIT_SOURCE_DRAWER_TAB_LABELS[tab]}
          </Text>
        </TabItem>
      ))}
    </FlexWrapper>
  );
};

export default EditSourceDrawerTabs;
